/**
 * Taro.showToast, for the web.
 *
 * The mini program calls showToast in ~36 places and the ported screens do the
 * same, so this exists to keep those call sites identical rather than sprinkle
 * bespoke banners around. A tiny event bus; <ToastHost/> renders it.
 */
export type ToastIcon = 'none' | 'success' | 'error'
export interface ToastMessage { id: number; title: string; icon: ToastIcon; duration: number }

type Listener = (message: ToastMessage) => void
const listeners = new Set<Listener>()
let nextId = 1

export function showToast(options: { title: string; icon?: ToastIcon; duration?: number }) {
  const message: ToastMessage = {
    id: nextId++,
    title: options.title,
    icon: options.icon || 'none',
    duration: options.duration ?? 1800
  }
  listeners.forEach((listener) => listener(message))
}

export function onToast(listener: Listener) {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
